import type { TranslationValues } from "next-intl";
import { getLocalePrice } from "@/lib/utilities";
import type { KeyValuePairProps } from "../components/pricing/price-element";
import type { ConfigurationPrice } from "../types/configuration-price.type";

export const DeliveryKV = ({
  pricing,
  t,
}: {
  pricing?: ConfigurationPrice;
  t: (key: string, values?: TranslationValues) => string;
}): KeyValuePairProps[] => {
  return pricing
    ? [
        {
          label: t("cart.pricing.delivery"),
          value: getLocalePrice({
            price: pricing.gross ?? 0,
          }),
          className: "font-normal",
          valueClassName: "font-bold",
          testId: "delivery",
        },
      ]
    : [];
};
